<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item>证书管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="10" class="search-wrapper">
      <el-col :span="4" style="padding-left: 0">
        <div class="grid-content">
          <el-select v-model="schoolId" clearable placeholder="学校库存" style="width: 100%;">
            <el-option
              v-for="item in schoolOptions"
              :key="item.uuid"
              :label="item.schoolName"
              :value="item.uuid">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="3" style="padding-left: 0">
        <div class="grid-content">
          <el-input clearable placeholder="教练NO" v-model="insNo">
          </el-input>
        </div>
      </el-col>
      <el-col :span="3">
        <div class="grid-content">
          <el-select v-model="status" clearable placeholder="证书状态" style="width: 100%;">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <el-select v-model="receiveType" clearable placeholder="收货类型" style="width: 100%;">
            <el-option
              v-for="item in receiveOption"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="3" style="padding-left: 0">
        <div class="grid-content">
          <el-input clearable placeholder="学员手机号" v-model="stuPhone"></el-input>
        </div>
      </el-col>
      <el-col :span="3">
        <div class="grid-content">
          <el-button
            style="width: 100%;"
            type="primary"
            @click="search"
          >查询
          </el-button>
        </div>
      </el-col>
    </el-row>
    <el-button
      type="primary"
      size="mini"
      class="add-btn"
      :disabled="!certSelects.length"
      @click="goToPrint"
    >选中打印
    </el-button>
    <el-button
      type="primary"
      size="mini"
      class="add-btn"
      :disabled="!certSelects.length"
      @click="goToExpress"
    >选中发货
    </el-button>
    <el-table
      ref="multipleTable"
      :data="certList"
      :max-height="tableHeight"
      style="width: 100%"
      @selection-change="certSelection">
      <el-table-column
        fixed="left"
        type="selection"
        align="center"
        width="55">
      </el-table-column>
      <el-table-column
        prop="ownerName"
        label="库存所有者"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="statusDesc"
        label="证书状态"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="receiveTypeDesc"
        label="收货类型"
        align="center"
        width="80">
      </el-table-column>
      <el-table-column
        prop="certType"
        label="证书类型"
        align="center"
        width="200">
      </el-table-column>
      <el-table-column
        prop="skiResort"
        label="雪场"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="stuName"
        label="学员姓名"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="stuPhone"
        label="手机号"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="entryTime"
        label="最近更新时间"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="goToDetail(scope.row)"
          >查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @current-change="handleCurrentChange"
      prev-text="上一页"
      next-text="下一页"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script type="text/ecmascript-6">
  import { listType } from '../common/js/config';
  import { getSchools } from '@/api/order';
  import { getCertList, certExpressPre } from '@/api/cert';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'cert_list',
    data() {
      return {
        statusOptions: [{
          value: 0,
          label: '未打印'
        }, {
          value: 1,
          label: '已打印'
        }, {
          value: 2,
          label: '已发货'
        }],
        receiveOption: [{
          value: 's',
          label: '学员自收'
        }, {
          value: 'o',
          label: '学校或教练代收'
        }],
        certSelects: [],
        status: null,
        stuPhone: '',
        receiveType: '',
        schoolOptions: [],
        schoolId: '',
        insNo: '',
        currentPage: 1,
        total: 0,
        tableHeight: 500,
        pageSize: 3
      };
    },
    created() {
      this._getSchools();
      if (!this.$route.params.pageNum) {
        this.$router.push('/student_list/1');
        this.currentPage = 1;
        this._getCertList(1);
      } else {
        this._getCertList(this.$route.params.pageNum);
        this.currentPage = parseInt(this.$route.params.pageNum);
      }
    },
    mounted() {
      let certHeight = document.body.clientHeight;
      this.tableHeight = certHeight - 284;
    },
    methods: {
      _getSchools() {
        getSchools(this.user.userId).then((res) => {
          this.schoolOptions = res.schools;
        });
      },
      search() {
        this.$router.push('/cert_list/1');
        this.currentPage = 1;
        this._getCertList(1);
      },
      goToPrint() {
        this.$router.push({
          name: 'cert_print',
          params: {
            certSelects: this.certSelects
          }
        });
      },
      goToExpress() {
        let certIds = [];
        this.certSelects.forEach((item) => {
          certIds.push(item.id);
        });
        certExpressPre(this.user.userId, certIds).then((res) => {
          if (res.rspCode === 0) {
            this.$router.push({
              name: 'cert_express',
              params: {
                certSelects: this.certSelects,
                addressStr: res.addressStr
              }
            });
          } else {
            this.$message.error(res.rspDesc);
          }
        }).catch(() => {
          this.$message.error('系统异常，请重试！');
        });
      },
      goToDetail(item) {
        this.setItem({
          item,
          type: listType.CERT
        });
        this.$router.push(`/cert_detail/${item.id}`);
      },
      _getCertList(pageNum) {
        getCertList(
          this.user.userId,
          pageNum,
          this.status,
          this.stuPhone,
          this.receiveType,
          this.schoolId,
          this.insNo,
        ).then((res) => {
          this.total = res.count;
          this.pageSize = res.pageSize;
          this.setList({
            list: res.certInfoList,
            type: listType.CERT
          });
        });
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.$router.push(`/cert_list/${val}`);
        this._getCertList(val);
      },
      certSelection(val) {
        this.certSelects = val;
      },
      ...mapActions([
        'setList',
        'setItem'
      ])
    },
    computed: {
      ...mapGetters([
        'certList',
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    height: 100%;
    overflow: scroll;
    .title
      margin-bottom: 20px;
    .search-wrapper
      margin: 0 0 10px 0 !important;
    .add-btn
      margin-bottom: 10px;
    .table
      margin-bottom: 20px;
    .pagination
      margin-top: 10px;
</style>